import { render, staticRenderFns } from "./UserNavMenu.vue?vue&type=template&id=2da54e08"
import script from "./UserNavMenu.vue?vue&type=script&lang=js"
export * from "./UserNavMenu.vue?vue&type=script&lang=js"
import style0 from "./UserNavMenu.vue?vue&type=style&index=0&id=2da54e08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports